export default "__VITE_ASSET__8cc4dc68__"